import script from "./TachoPrivateMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./TachoPrivateMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./TachoPrivateMonitoring.vue?vue&type=style&index=0&id=7bda28a4&scoped=true&lang=css"
import "./TachoPrivateMonitoring.vue?vue&type=style&index=1&id=7bda28a4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bda28a4"]])

export default __exports__